// NEW SCRIPT VERSION
document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("quickAddModal")) {
    const modalTemplate = `
      <div id="quickAddModal" class="quick-add-modal" style="display: none;">
        <div class="quick-add-modal__overlay"></div>
        <div class="quick-add-modal__content">
          <div class="modal-header">
            <h5 class="modal-title">Added to bag</h5>
            <button type="button" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="atc-modal__item">
              <img class="img-fluid d-none d-md-block quick-add-modal__product-image" src="" alt="">
              <div class="atc-modal__item-info">
                <div class="message">
                  <h4 class="product-title"></h4>
                </div>
                <div class="cart-path-buttons">
                  <button type="button" class="keep-shopping">Keep Shopping</button>
                  <a href="/cart" class="view-bag">View bag</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;

    document.body.insertAdjacentHTML("beforeend", modalTemplate);
  }

  const forms = document.querySelectorAll(".custom-add-to-cart-form");
  const modal = document.getElementById("quickAddModal");
  const closeButton = modal.querySelector(".close");
  const keepShoppingButton = modal.querySelector(".keep-shopping");
  const modalOverlay = modal.querySelector(".quick-add-modal__overlay");

  // Function to close modal
  const closeModal = () => {
    modal.style.display = "none";
    document.body.classList.remove("modal-open");
  };

  // Add event listeners for closing modal
  [closeButton, keepShoppingButton, modalOverlay].forEach((element) => {
    element.addEventListener("click", closeModal);
  });

  forms.forEach((form) => {
    const button = form.querySelector(".product-card__quick-add-button");
    const modal_id = button.getAttribute("data-modal-id");

    const data = document.getElementById(modal_id);
    const productImage = modal.querySelector(".quick-add-modal__product-image");
    const productTitle = modal.querySelector(".product-title");

    const src = data.querySelector(".quick-add-modal__product-image").src;
    const title = data.querySelector(".product-title").textContent;

    button.addEventListener("click", function () {
      console.log("Product added to cart", modal_id);

      productImage.src = src;
      productTitle.textContent = title;
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    });
  });
});

// OLD SCRIPT
// // Create and inject modal HTML
// document.addEventListener("DOMContentLoaded", () => {
//   // Create modal container if it doesn't exist
//   if (!document.getElementById("quickAddModal")) {
// const modalTemplate = `
//   <div id="quickAddModal" class="quick-add-modal" style="display: none;">
//     <div class="quick-add-modal__overlay"></div>
//     <div class="quick-add-modal__content">
//       <div class="modal-header">
//         <h5 class="modal-title">Added to bag</h5>
//         <button type="button" class="close" aria-label="Close">
//           <span aria-hidden="true">&times;</span>
//         </button>
//       </div>
//       <div class="modal-body">
//         <div class="atc-modal__item">
//           <img class="img-fluid d-none d-md-block quick-add-modal__product-image" src="" alt="">
//           <div class="atc-modal__item-info">
//             <div class="message">
//               <h4 class="product-title"></h4>
//             </div>
//             <div class="cart-path-buttons">
//               <button type="button" class="keep-shopping">Keep Shopping</button>
//               <a href="/cart" class="view-bag">View bag</a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>`;

//     document.body.insertAdjacentHTML("beforeend", modalTemplate);
//   }

//   // Initialize modal elements
//   const modal = document.getElementById("quickAddModal");
//   const closeButton = modal.querySelector(".close");
//   const keepShoppingButton = modal.querySelector(".keep-shopping");
//   const modalOverlay = modal.querySelector(".quick-add-modal__overlay");

//   // Function to close modal
//   const closeModal = () => {
//     modal.style.display = "none";
//     document.body.classList.remove("modal-open");
//   };

//   // Add event listeners for closing modal
//   [closeButton, keepShoppingButton, modalOverlay].forEach((element) => {
//     element.addEventListener("click", closeModal);
//   });

//   // Handle quick add buttons
//   let isSubmitting = false;

//   const handleQuickAdd = async (event, button) => {
//     event.preventDefault();
//     event.stopPropagation();

//     if (isSubmitting) return;

//     isSubmitting = true;
//     const productCard = button.closest("product-card");
//     const productHandle = productCard.getAttribute("handle");

//     try {
//       // Get product data
//       const productResponse = await fetch(`/products/${productHandle}.js`);
//       const product = await productResponse.json();

//       // Get first available variant
//       const variant = product.variants[0];

//       // Prepare form data
//       const formData = new FormData();
//       formData.append("id", variant.id);
//       formData.append("quantity", 1);

//       // Add to cart
//       const cartResponse = await fetch(
//         window.Shopify.routes.root + "cart/add.js",
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       const cartData = await cartResponse.json();

//       // Update modal content
//       const productImage = modal.querySelector(
//         ".quick-add-modal__product-image"
//       );
//       const productTitle = modal.querySelector(".product-title");

//       if (productImage) productImage.src = product.featured_image;
//       if (productTitle) productTitle.textContent = product.title;

//       // Update cart count
//       const cartCountResponse = await fetch(
//         window.Shopify.routes.root + "cart.js"
//       );
//       const cart = await cartCountResponse.json();

//       document.querySelectorAll("cart-count").forEach((count) => {
//         count.textContent = cart.item_count;
//       });

//       document.querySelectorAll(".header__cart-count").forEach((count) => {
//         count.classList.add("is-visible");
//       });

//       // Show modal
//       modal.style.display = "block";
//       document.body.classList.add("modal-open");
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//     } finally {
//       isSubmitting = false;
//     }
//   };

//   // Attach event listeners to all quick add buttons
//   const quickAddButtons = document.querySelectorAll(
//     ".product-card__quick-add-button"
//   );
//   quickAddButtons.forEach((button) => {
//     button.addEventListener("click", (event) => handleQuickAdd(event, button));
//   });
// });
